<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" width="800px">
        <v-card class="dialog_round pa-10">
          
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12">
                  <v-text-field single-line v-model="editedItem.TITLE" outlined
                  :label="$t('eventnotice_label1')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col md="6" sm="12" xs="12">
                    <v-select outlined v-model="editedItem.TYPE" :items="TYPELIST" :label="$t('eventnotice_col2')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                  </v-col>
                  <v-col md="6" sm="12" xs="12">
                    <v-select outlined v-model="editedItem.FIX" :items="FIXLIST" :label="$t('eventnotice_label2')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="12" sm="12" xs="12">
                  <editor
                    :initialValue="editorText"
                    :options="editorOptions"
                    height="500px"
                    initialEditType="wysiwyg"
                    previewStyle="vertical"
                    ref="toastuiEditor"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col clos="12" md="8" sm="8" xs="8">
                    <v-text-field disabled single-line v-model="editedItem.FILENAME" :label="$t('eventnotice_label3')"></v-text-field>
                  </v-col>
                  <v-col clos="12" md="2" sm="2" xs="2">
                    <v-btn class="fairpass_btn_freesize" rounded large @click="delete_file(editedItem)">{{$t('eventnotice_label4')}}</v-btn>        
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12">
                    <v-file-input  :label="$t('eventnotice_label5')" v-model="uploadFile"/>
                  </v-col>
                </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row dense justify="center">
              <v-col cols="12" md="12" sm="12" xs="12">
                <div style="background:#4e6ef7;height:2px;" />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-card-actions>
            <v-row justify="center">
              <v-btn class="dialog_cancel_btn mr-5" rounded large @click="close">{{$t("common_cancel")}}</v-btn>
              <v-btn class="dialog_btn" rounded large @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="progress_dialog" width="400px">
        <v-row justify="center">
          <v-col cols="2">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
              />
          </v-col>
        </v-row>
        <v-row justify="center">
            <label>{{$t('eventnotice_label6')}}</label>
        </v-row>
      </v-dialog>  
    </v-row>    

    <v-row dense align="center">
      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      
      <template v-if="grade >= 50">
        <v-col  md="3" sm="12" xs="12" class="pa-0">
          <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
        </v-col>
        <v-col cols="12" md="3" sm="12" xs="12" class="pa-0">
          <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
        </v-col>
      </template>
      <template v-else>
        <v-col cols="12" offset-md="3" md="3" sm="12" xs="12" class="pa-0">
          <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
        </v-col>
      </template>
      
      <v-col cols="12" md="2" sm="12" xs="12" class="pa-0">
        <v-text-field 
          dense single-line clearable
          @keyup.enter="search_run" 
          v-model="search_keyword" 
          :placeholder="$t('common_search_holder')"
          outlined height="43"
          color="#808080"
          hide-details
          />
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="search_run">{{$t("common_search")}}</v-btn>
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">        
        <v-btn style="width:94%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>
      
  </v-row>
  
  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>
    
  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        v-model="selected"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        
        class="datatablestyle"
        :items-per-page="pagerow"
        :search="search"  
        item-key="IDX"
        :loading="loading"
        >
        <template v-slot:header.TITLE>
          <a :class="sort_name=='TITLE'?'cheader_sortselect':'cheader_sort'" @click="customsort('TITLE')">{{$t("eventnotice_col1")}}</a>
        </template>
        <template v-slot:header.TYPE_NAME>
          <a :class="sort_name=='TYPE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort('TYPE_NAME')">{{$t("eventnotice_col2")}}</a>
        </template>
        <template v-slot:header.FIX>
          <label class="cheader_normal" >{{$t("eventnotice_col3")}}</label>
        </template>
        <template v-slot:header.UP_DATE>
          <a :class="sort_name=='UP_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('UP_DATE')">{{$t("eventnotice_col4")}}</a>
        </template>
        <template v-slot:header.REG_DATE>
          <a :class="sort_name=='REG_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort('REG_DATE')">{{$t("eventnotice_col5")}}</a>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("eventnotice_col6")}}</label>
        </template>

        <template v-slot:item.FIX="{ item }">  
          <template v-if="item.FIX == 1">
            <label style="color:green;text-align:center">{{$t('eventnotice_col7')}}</label>
          </template>
          <template v-else>
            <label style="color:red;text-align:center">{{$t('eventnotice_col8')}}</label>
          </template>
        </template>     
        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  <!-- 하단 페이징 영역 -->
  <v-row align="start">
    <v-col cols="12" md="1"/>
    <v-col cols="12" md="2">
      <v-text-field
        v-model="search"
        append-icon="search"
        :label="$t('common_filter')"
        single-line
        hide-details
        outlined height="43"
        color="#808080"
        dense
        />
    </v-col>
    <v-col cols="12" md="6" class="d-flex justify-center">
      <v-btn v-if="bottompage > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
      <span v-for="n in subpage" :key="n.id">
          <span v-if="page == bottompage-1+n">
              <v-btn color="red" icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
          <span v-else>
              <v-btn icon small @click="loadpage(bottompage-1+n)">{{bottompage-1+n}}</v-btn>
          </span>
      </span>
      <v-btn v-if="subpage == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
    </v-col>
    <v-col cols="12" md="2">
      <v-select
        v-model="pagerow"
        :items="pagerow_combo"
        item-text="NAME"      
        item-value="VALUE"
        :label="$t('common_rownum')"
        min-width="150px"
        outlined height="43"
        color="#808080"
        dense
        ></v-select>
    </v-col>
    <v-col cols="12" md="1"/>
  </v-row>

  
  

  </v-container>
</template>

<script>
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/vue-editor';
import 'tui-color-picker/dist/tui-color-picker.css';
import colorSyntax from '@toast-ui/editor-plugin-color-syntax';

export default {

    components:{
      editor:Editor
    },

    data: () => ({
      editorText: {},
      editorOptions : {
                        minHeight: '200px',
                        language: 'en-US',
                        useCommandShortcut: true,
                        useDefaultHTMLSanitizer: true,
                        usageStatistics: false,
                        hideModeSwitch: false,
                        plugins:[colorSyntax],
                        toolbarItems: [
                          'heading',
                          'bold',
                          'italic',
                          'strike',
                          'divider',
                          //'hr',
                          'quote',
                          'divider',
                          'ul',
                          'ol',
                          'task',
                          //'indent',
                          //'outdent',
                          'divider',
                          //'table',
                          'image',
                          'link',
                          'divider',
                          //'code',
                          //'codeblock'
                        ]
                      },
            
      uploadFile : [],

      //필수 페이징 파라메터
      totalcnt : 0,       //전체 아이템 개수
      page : 0,
      maxpage : 0,        //전체 페이지 개수
      startpage : 1,      //시작 인덱스
      bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
      subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      progress_dialog:false,
      defaultItem: {
          IDX:0,
          TITLE:'',
          DESC:'',
          TYPE:1,
          FIX:0,
          FILE1:'',
          FILE2:'',
          FILE3:'',
      },
      editedItem: {
      },
      selected:[],              //테이블에 선택된 아이템 리스트

      //테이블 정의
      headers: [
        {text: '제목', value: 'TITLE', sortable: false, align:'center'},
        {text: '타입', value: 'TYPE_NAME', sortable: false, align:'center'},
        {text: '고정', value: 'FIX', sortable: false, align:'center'},
        {text: '수정일시', value: 'UP_DATE', sortable: false, align:'center' },
        {text: '등록일시', value: 'REG_DATE', sortable: false, align:'center' },
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],

      //검색 파라메터
      sort_name: 'TITLE',
      sort_type: true,    //true : DESC, false: ASC

      search_keyword : '',
      search: '',         //필터링용 검색어

      //한 페이지 ROW 개수 설정
      pagerow : 20,       //한 페이지에 보여줄 row수
      pagerow_combo : [
          {NAME:'20', VALUE:20}
        , {NAME:'50', VALUE:50}
        , {NAME:'100', VALUE:100}
        , {NAME:'200', VALUE:200}
      ],    
         
      //추가 변수들
      TYPELIST: [
          {name:'비활성', name2:"Disable", value:0}
        , {name:'활성',  name2:"Enable", value:1}
      ],

      //추가 변수들
      FIXLIST: [
          {name:'사용안함', name2:"Not Used", value:0}
        , {name:'상단고정', name2:"Fix", value:1}
      ],

      //편집창 상단 버튼
      /*
      extensions: [
        History,      //undo, redo인거 같아
        //Blockquote,   //쌍따옴표라는데 | 나온다.
        Link,         //링크
        Underline,    //밑줄
        Strike,       //가운데줄
        Image,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [Heading, {
          options: {
            levels: [1, 2, 3]
          }
        }],
        Bold,
        //Code,
        HorizontalRule,
        Paragraph
        //HardBreak
      ],
      */

      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

    }),

    mounted(){
      
      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){
      
    },

    methods: {

      customsort(sortname){
        this.sort_name = sortname;
        this.sort_type = !this.sort_type;
        this.loadpage(this.page);
      },

      prev(){
          this.bottompage = this.bottompage - 10 >= 1 ? this.bottompage - 10 : 1;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage + this.subpage - 1; //이전을 누르면 가장 끝 번호 선택
          this.loadpage(temp_page);
      },
      next(){
          this.bottompage = this.bottompage + 10 <= this.maxpage ? this.bottompage + 10 : this.maxpage;
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
          var temp_page = this.bottompage;
          this.loadpage(temp_page);
      },

      makepaging(){
        var div1 = this.totalcnt / this.pagerow; 
        var div2 = this.totalcnt % this.pagerow;
        if(div2 == 0){  
            this.maxpage = parseInt(div1);    
        }else{
            this.maxpage = parseInt(div1+1);
        }
        if(this.bottompage == 1){
          this.subpage = this.maxpage - this.bottompage >= 10 ? 10 : this.maxpage - this.bottompage+1;
        }
      },

      loadpage(p){

          if(this.loading){
            return;
          }

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화

          if(this.SEARCH_COM_IDX == null){
            this.$alert(this.$t('common_select_tcom'));
            return;
          }
          if(this.SEARCH_EVENT_IDX == null){
            this.$alert(this.$t('common_select_tevent'));
            return;
          }

          this.loading = true;
          this.page = p;

          this.$http.post(this.$host+'/api/EventNoticeList',{
                search_keyword: this.search_keyword == null || this.search_keyword == undefined ?  '' : escape(this.search_keyword)
              , sort_name:this.sort_name
              , sort_type: this.sort_type==true ? "DESC" : "ASC" 
              , page: this.page
              , pagerow: this.pagerow
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{

            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.totalcnt = result.data.totalcnt;
                this.makepaging();
                const list = result.data.resultData;
                
                list.forEach(element => {

                  
                  if(element.FILE1 != undefined && element.FILE1 != null && element.FILE1.length > 0){
                      const last = element.FILE1.split("/");
                      const encodedFilename = last[last.length-1];
                      
                      try {
                          // decodeURIComponent가 더 정확합니다
                          element.FILENAME = decodeURIComponent(encodedFilename);
                      } catch (e) {
                          console.error('Decode error for:', encodedFilename);
                          // 오류 발생 시 원본 유지
                          element.FILENAME = encodedFilename;
                      }
                  } else {
                      element.FILENAME = "";
                  }          
                  
                  this.itemList.push(element); 

                });
                this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(`error : ${error.message}`);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage(1);
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.uploadFile = [];
        }, 300)
      },

      //추가 저장
      async save () {
        
        //에디터에서 값 가져오기
        this.editedItem.DESC = this.$refs.toastuiEditor.invoke('getHtml');

        if(this.uploadFile.size/1024/1024 > 50){
          this.$alert(this.$t('eventnotice_msg1'));
          return;
        }

        if (this.editedIndex > -1) {

          if(this.editedItem.TITLE == undefined || this.editedItem.TITLE.length < 1){
            this.$alert(this.$t('eventnotice_msg2'));
            return;
          } 

          if(this.editedItem.DESC == undefined || this.editedItem.DESC.length < 1){
            this.$alert(this.$t('eventnotice_msg3'));
            return;
          } 

          this.progress_dialog = true;

          //여기서 이미지 태그를 추출해서 base64 이미지를 s3에 업로드하고 url을 받아서 src를 교체한다.
          const temp_div = document.createElement("div");
          temp_div.innerHTML = this.editedItem.DESC;
          const imgs = temp_div.getElementsByTagName("img");

          //순차처리 가능
          for(const img of imgs){

              //여기서 업로드하고 리턴받아서 html의 돔을 교체해야한다.
              const imgstr = String(img.src);
              if(imgstr.startsWith("data:image")){
              
                const file = this.dataURLtoFile(img.src,'temp.png');
                const formData = new FormData();
                formData.append("FOLDER", this.SEARCH_COM_IDX+"/eventnotice");
                formData.append("customfile", file);
                await this.$http.post(this.$host+'/api/UploadImage', formData, {
                  headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
                })
                .then((result)=>{
                  
                  if(result.data.resultCode == 0){

                    //토큰 저장
                    if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                      this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                    }
                    if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                      this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                    }

                    //성공
                    const fileurl = result.data.resultData[0].fileurl;
                    
                    //변경
                    img.src = fileurl;

                  }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동
                  }
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                });

                //console.log("업로드 했다 치고...2" + img.src);

              }
          }

          //교체
          this.editedItem.DESC = temp_div.innerHTML;

          //수정
          this.loading = true;
          const formData = new FormData();

          //수정의 경우 파일 정보가 변경된 경우에만 새로 업로드 한다.
          var tempfolder = Date.now().toString();
          formData.append("FOLDER", this.SEARCH_COM_IDX+"/eventnotice/"+tempfolder);
          formData.append("TITLE", this.editedItem.TITLE);
          formData.append("DESC", this.editedItem.DESC);
          formData.append("TYPE", this.editedItem.TYPE);
          formData.append("FIX", this.editedItem.FIX);
          formData.append("IDX",  this.editedItem.IDX);
          formData.append("customfile", this.uploadFile);
          this.$http.post(this.$host+'/api/EventNoticeUpdate',formData,{
            headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
          })
          .then((result)=>{
            this.loading = false;
            this.progress_dialog = false;
            if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loadpage(this.page);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });

        }else{

          if(this.editedItem.TITLE == undefined || this.editedItem.TITLE.length < 1){
            this.$alert(this.$t('eventnotice_msg2'));
            return;
          } 

          if(this.editedItem.DESC == undefined || this.editedItem.DESC.length < 1){
            this.$alert(this.$t('eventnotice_msg3'));
            return;
          } 

          this.progress_dialog = true;

          //여기서 이미지 태그를 추출해서 base64 이미지를 s3에 업로드하고 url을 받아서 src를 교체한다.
          const temp_div = document.createElement("div");
          temp_div.innerHTML = this.editedItem.DESC;
          const imgs = temp_div.getElementsByTagName("img");

          //순차처리 가능
          for(const img of imgs){

              //여기서 업로드하고 리턴받아서 html의 돔을 교체해야한다.
              const imgstr = String(img.src);
              if(imgstr.startsWith("data:image")){
              
                const file = this.dataURLtoFile(img.src,'temp.png');
                const formData = new FormData();
                formData.append("FOLDER", this.SEARCH_COM_IDX+"/eventnotice");
                formData.append("customfile", file);
                await this.$http.post(this.$host+'/api/UploadImage', formData, {
                  headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
                })
                .then((result)=>{
                  
                  if(result.data.resultCode == 0){

                    //토큰 저장
                    if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                      this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                    }
                    if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                      this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                    }

                    //성공
                    const fileurl = result.data.resultData[0].fileurl;
                    
                    //변경
                    img.src = fileurl;

                  }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                  }
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                });

              }
          }

          //교체
          this.editedItem.DESC = temp_div.innerHTML;

          //수정
          this.loading = true;
          const formData = new FormData();
          var tempfolder2 = Date.now().toString();
          formData.append("FOLDER", this.SEARCH_COM_IDX+"/eventnotice/"+tempfolder2);
          formData.append("TITLE", this.editedItem.TITLE);
          formData.append("DESC", this.editedItem.DESC);
          formData.append("TYPE", this.editedItem.TYPE);
          formData.append("FIX", this.editedItem.FIX);
          formData.append("COM_IDX", this.SEARCH_COM_IDX);
          formData.append("EVENT_IDX", this.SEARCH_EVENT_IDX);
          formData.append("customfile", this.uploadFile);
          this.$http.post(this.$host+'/api/EventNoticeInsert',formData,{
            headers:{'Content-Type': 'multipart/form-data',accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}
          })
          .then((result)=>{
            this.loading = false;
            this.progress_dialog = false;
            if(result.data.resultCode == 0){
                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                  this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                  this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  const p = this.page;
                  this.page = 0;
                  this.loadpage(p);
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });

        }

        this.close()
      },      

      //검색
      search_run(){
        this.loadpage(1);
      },
      

      //신규 추가
      newinsert(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.uploadFile = [];
        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.DESC  = "";
        this.editorText = this.editedItem.DESC;
        this.dialog = true;
        this.$refs.toastuiEditor.invoke('setHtml', this.editedItem.DESC); //팝업이 떠서 에디터가 생성된 후 읽을 수 있다.            
      },

      //아이템 수정
      edit_item(item){

        //내용 가져오기
        this.loading = true;
        this.$http.post(this.$host+'/api/EventNoticeDetail',{
              IDX: item.IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{

          this.loading = false;
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            this.dialogTitle = this.$t('common_edit_title');
            this.editedIndex = this.itemList.indexOf(item)
            //this.editedItem = item;
            this.editedItem = Object.assign({}, item);

            //이미 선택된 아이템에 상세만 교체
            this.editedItem.DESC  = result.data.resultData[0].DESC;
           
            this.editorText = this.editedItem.DESC;
            this.dialog     = true;
            this.$refs.toastuiEditor.invoke('setHtml', this.editedItem.DESC); //팝업이 떠서 에디터가 생성된 후 읽을 수 있다.

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
        });

      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/EventNoticeDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      delete_file(item){

        if(item.FILE1 == null || item.FILE1 == undefined || item.FILE1.length < 1){
          this.$alert(this.$t('eventnotice_msg4'));
          return;
        }

        this.$confirm(this.$t('eventnotice_msg5'))
        .then(() => {
          this.close(); //팝업 닫기
          this.loading = true;
          this.$http.post(this.$host+'/api/EventNoticeFileDelete',{
              IDX:item.IDX
            , ADMIN_IDX:item.ADMIN_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
              this.$alert(this.$t("common_delete_com")).then(()=>{
                const p = this.page;
                this.page = 0;
                this.loadpage(p);
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //base64 이미지 데이터를 파일로 변환
      dataURLtoFile(dataurl, fileName){
 
        var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
            
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        
        return new File([u8arr], fileName, {type:mime});

      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        console.log(`val1 : ${JSON.stringify(val1)}`);
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage(1);                  
      },


      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
        }
        this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
        this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
        this.SEARCH_EVENT_IDX  = null;
        this.SEARCH_EVENT_NAME = '';
        this.$session.set("EVENT_IDX", null);
        this.$session.set("EVENT_NAME", "");
        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      },
      
      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
      },



    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>


</style>